import { useMemo } from 'react';
import { Index } from 'lunr';
import warning from 'tiny-warning';
import invariant from 'tiny-invariant';
var useLunr = function useLunr(query, rawIndex, rawStore) {
  var index = useMemo(function () {
    if (rawIndex === undefined || rawIndex === null) {
      process.env.NODE_ENV !== "production" ? warning(rawIndex !== undefined && rawIndex !== null, 'No index was provided. Results will always be empty.') : void 0;
      return;
    }
    if (rawIndex instanceof Index) return rawIndex;
    if (typeof rawIndex === 'string') return Index.load(JSON.parse(rawIndex));
    if (typeof rawIndex === 'object') return Index.load(rawIndex);
    process.env.NODE_ENV !== "production" ? invariant(false, 'Invalid index provided. Please provide an instance of Lunr.Index or exported JSON or string index.') : invariant(false);
  }, [rawIndex]);
  var store = useMemo(function () {
    if (typeof rawStore === 'string') return JSON.parse(rawStore);
    return rawStore;
  }, [rawStore]);
  return useMemo(function () {
    if (!query || !index) return [];
    var results = index.search(query);
    if (store) return results.map(function (_ref) {
      var ref = _ref.ref;
      return store[ref];
    });
    return results;
  }, [query, index, store]);
};
export { useLunr };